const {h, render, Component} = require('preact');

class FlexibleFormSubmitView extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div class="submit-button" data-bhw="web2018_email_ticket_submit">
        <input class="submit-button btn" disabled
               type="button" onClick={this.props.onSubmitClick}
               value={I18n.translate('js.modules.support.submit')}/>
      </div>
    )
  }
}

module.exports = FlexibleFormSubmitView